import { Suspense, lazy } from 'react'
import StoreApp from '@!/Store/Common/containers/StoreApp'
import { AppProvider } from '@!/providers'
const FreeFeature = lazy(() => import('@!/Store/FreeFeature/containers/FreeFeature'))

const FreeFeatureApp = (props) => {
  return (
    <AppProvider>
      <StoreApp {...props}>
        <Suspense fallback={null}>
          <FreeFeature freeFeature={props.free_feature} campaign={props.campaign} />
        </Suspense>
      </StoreApp>
    </AppProvider>
  )
}

export default FreeFeatureApp
